import { X } from '@phosphor-icons/react';

export default X;
